<template lang="html">
  <section class="sublist-view" v-if="de">
    <div class="field-container">
      <label class="query-label">
        {{ getMessageText(messages.DATA_SOURCE) }}
      </label>
      <div class="selection">{{ dataSourceName }}</div>
    </div>
    <div class="field-container">
      <label class="query-label">
        {{ getMessageText(messages.SKIP) }}
      </label>
      <div class="selected-fields">
        <div>{{ de.skip }}</div>
      </div>
    </div>
    <div class="field-container">
      <label class="query-label">
        {{ getMessageText(messages.KEEP) }}
      </label>
      <div class="selected-fields">
        <div>{{ de.keep }}</div>
      </div>
    </div>
  </section>
</template>

<script lang="js">
  import { mapState } from "vuex";

  export default {
    name: "sublist-view",
    props: {
      deId: String,
      appId: String
    },
    computed: {
      ...mapState({
        apps: "apps",
        messages: "messages"
      }),
      app() {
        return this.apps.find(app => app.uuid === this.appId);
      },
      de() {
        return this.app.dataElements[this.deId];
      },
      dataSourceName() {
        const original = this.app.dataElements[this.de.original];
        return original? original.name : this.de.originLabel;
      }
    }
  }
</script>

<style scoped lang="scss">
  .sublist-view {
    .field-container {
      display: flex;
      flex-basis: 100%;
      .query-label {
        font-size: 0.85rem;
        font-weight: bold;
        flex-basis: 15%;
      }
      .selected-fields {
        display: inline-block;
      }
    }
  }
</style>
